module Meevo.Plugins.OnlineBookingSettings {
    import SettingsDto = Meevo.Model.SettingsDto;
    "use strict";

    /**
    * Employees Section of OnlineBooking Settings 
    */
    export class OnlineBookingEmployeesSection extends Meevo.Components.CommonClasses.SettingsSectionBase {
        private employeeIds: string[];
        private selectAll: boolean = false;

        public onlineBookingEmployeesCriteria = {
            showEmployeesOnly: true,
            includeInactive: false,
            selectModelBy: (item) => item['allowBookableOnline']
        };

        public activate(): void {

            this.isLoaded = true;
            if (Model.Guard.isNothing(this.model.onlineBookingEmployees)) {
                this.model.onlineBookingEmployees = {
                    employeeCategoryIds: [],
                    employeeIds: []
                };
            }
        }

        public preSave(): any {
            this.employeeIds = this.model.onlineBookingEmployees.employeeIds || [];      
            return this.dataService.customMethodData(`/api/Employee/AllowOnlineBooking`, 'PATCH', {
                employeesAllowOnlineBooking: this.employeeIds,
                selectAll: this.selectAll
            }).then((res) => {
                
                return this.model;
            });
        }
        
    }
}